import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SafeHtml } from '@angular/platform-browser';
import { Safe } from '../../../../pipes/safeHtml.pipe';

interface StatementRow {
  statementText: string;
  qualifier: string;
  marketingChannel: string;
  supportStrategy: string;
  substantiations: string;
  qualifierBold?: boolean;
  marketingChannelExpanded?: boolean; // for expansion state
  claim_la_bid?: any;
  claim_la_id?: any;
  claim_la_name?: any;
  claim_la_order?: any;
  slno?: any;
  claimReviewData?: any;
  apiSubstantiations?: any;
  _userAddedSubstantiations?: any;
  substantiation_permission?: any;
  editing_permission?: any;
  claim_la_state_ui?: any;
}

@Component({
  selector: 'app-claims-review-popup',
  standalone: true,
  imports: [
    CommonModule,
    MatTableModule,
    MatButtonModule,
    MatTooltipModule,
    Safe,
  ],
  templateUrl: './claims-review-popup.component.html',
  styleUrl: './claims-review-popup.component.scss',
})
export class ClaimsReviewPopupComponent {
  constructor(
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<ClaimsReviewPopupComponent>
  ) {}

  displayedColumns = [
    'statementText',
    'qualifier',
    'marketingChannel',
    'supportStrategy',
    'substantiations',
  ];

  savedInDraft: StatementRow[] = [];
  latestUpdates: StatementRow[] = [];
  isDeclineEnabled = false;

  ngOnInit() {
    // Get dialog data
    const dialogData = this.dialogRef._containerInstance._config.data;
    console.log(dialogData?.savedraftData, 'save draft dta');
    console.log(dialogData?.currentRowData, 'currentRowData dta');

    // Helper to clean apiSubstantiations array
    const cleanApiSubstantiations = (arr: any[]) => {
      return arr.filter((sub) =>
        Object.entries(sub).some(([key, val]) =>
          key !== 'isUserAdded' &&
          key !== 'fromClaimSubst' &&
          key !== 'textColorClass'
            ? val !== ''
            : false
        )
      );
    };

    // Assign savedraftData to savedInDraft
    if (dialogData?.savedraftData) {
      let mappedDraft = Array.isArray(dialogData.savedraftData)
        ? dialogData.savedraftData.map(this.mapRow)
        : [this.mapRow(dialogData.savedraftData)];

      mappedDraft = mappedDraft.map((draft) => ({
        ...draft,
        apiSubstantiations: cleanApiSubstantiations(
          dialogData.savedraftData.apiSubstantiations || []
        ),
        _userAddedSubstantiations:
          dialogData.savedraftData._userAddedSubstantiations || [],
      }));

      this.savedInDraft = mappedDraft;
      // Set isDeclineEnabled based on claim_la_state
      // if (
      //   this.savedInDraft.length > 0 &&
      //   (this.savedInDraft[0].claim_la_state_ui === 'Assessed')
      // ) {
      //   this.isDeclineEnabled = true;
      // } else {
      //   this.isDeclineEnabled = false;
      // }
      console.log(this.savedInDraft, 'Save Draft data assign');
    }

    // Assign currentRowData to latestUpdates
    if (dialogData?.currentRowData) {
      let mappedLatest = this.mapRow(dialogData.currentRowData);

      mappedLatest.apiSubstantiations = cleanApiSubstantiations(
        dialogData.savedraftData.apiSubstantiations || []
      );
      mappedLatest._userAddedSubstantiations =
        dialogData.savedraftData._userAddedSubstantiations || [];

      if (this.savedInDraft.length && this.savedInDraft[0].slno) {
        mappedLatest.slno = this.savedInDraft[0].slno;
      }
      this.latestUpdates = [mappedLatest];

      if (
        this.latestUpdates.length > 0 &&
        this.latestUpdates[0].claim_la_state_ui === 'Assessed'
      ) {
        this.isDeclineEnabled = true;
      } else {
        this.isDeclineEnabled = false;
      }
      console.log(this.latestUpdates, 'Latest Updates data assign');
    }
  }

  // Helper to map raw row data to StatementRow structure
  mapRow(row: any): StatementRow {
    // Determine if this is a savedraft row (backend keys) or current row (frontend keys)
    console.log(row, 'mapped row in calim review');
    const isSavedraft = !!row.statement || !!row.support_strategy_rich;
    // Extract substantiations as array of objects
    let substantiationsArr: any = [];
    // if (row.substantiations) {
    //   if (Array.isArray(row.substantiations)) {
    //     substantiationsArr = row.substantiations.map((s: any) => {
    //       if (isSavedraft) {
    //         return {
    //           substantiation_id: s['substantiation__vr.name__v'] || '',
    //           description: s['substantiation__vr.description__v'] || '',
    //           details: s['substantiation__vr.substantiation_details__c'] || '',
    //           geography: s['country__cr.name__v'] || '',
    //           subtype: s['related_reference__vr.subtype__v'] || '',
    //           link: s['substantiation_link'] || '',
    //         };
    //       } else {
    //         return {
    //           substantiation_id: s['substantiation_id'] || s['name'] || '',
    //           description: s['description'] || '',
    //           details: s['details'] || '',
    //           geography: s['geography'] || '',
    //           subtype: s['subtype'] || '',
    //           link: s['link'] || s['substantiation_link'] || '',
    //         };
    //       }
    //     });
    //   } else if (typeof row.substantiations === 'object') {
    //     substantiationsArr = [
    //       {
    //         substantiation_id: isSavedraft
    //           ? row.substantiations['substantiation__vr.name__v'] || ''
    //           : row.substantiations['substantiation_id'] || '',
    //         description: isSavedraft
    //           ? row.substantiations['substantiation__vr.description__v'] || ''
    //           : row.substantiations['description'] || '',
    //         details: isSavedraft
    //           ? row.substantiations[
    //               'substantiation__vr.substantiation_details__c'
    //             ] || ''
    //           : row.substantiations['details'] || '',
    //         geography: isSavedraft
    //           ? row.substantiations['country__cr.name__v'] || ''
    //           : row.substantiations['geography'] || '',
    //         subtype: isSavedraft
    //           ? row.substantiations['related_reference__vr.subtype__v'] || ''
    //           : row.substantiations['subtype'] || '',
    //         link: isSavedraft
    //           ? row.substantiations['substantiation_link'] || ''
    //           : row.substantiations['link'] ||
    //             row.substantiations['substantiation_link'] ||
    //             '',
    //       },
    //     ];
    //   }
    // }
    if (row.substantiations) {
      if (Array.isArray(row.substantiations)) {
        substantiationsArr = row.substantiations
          .map((s: any) => {
            let substObj;
            if (isSavedraft) {
              substObj = {
                substantiation_id: s['substantiation__vr.name__v'] || '',
                description: s['substantiation__vr.description__v'] || '',
                details:
                  s['substantiation__vr.substantiation_details__c'] || '',
                geography: s['country__cr.name__v'] || '',
                subtype: s['related_reference__vr.subtype__v'] || '',
                link: s['substantiation_link'] || '',
              };
            } else {
              substObj = {
                substantiation_id: s['substantiation_id'] || s['name'] || '',
                description: s['description'] || '',
                details: s['details'] || '',
                geography: s['geography'] || '',
                subtype: s['subtype'] || '',
                link: s['link'] || s['substantiation_link'] || '',
              };
            }
            // If all values are empty, return null
            return Object.values(substObj).every((val) => val === '')
              ? null
              : substObj;
          })
          .filter((subst) => subst !== null);
        // If after filtering, substantiationsArr is empty, assign empty array
        if (substantiationsArr.length === 0) substantiationsArr = [];
      } else if (typeof row.substantiations === 'object') {
        const substObj = {
          substantiation_id: isSavedraft
            ? row.substantiations['substantiation__vr.name__v'] || ''
            : row.substantiations['substantiation_id'] || '',
          description: isSavedraft
            ? row.substantiations['substantiation__vr.description__v'] || ''
            : row.substantiations['description'] || '',
          details: isSavedraft
            ? row.substantiations[
                'substantiation__vr.substantiation_details__c'
              ] || ''
            : row.substantiations['details'] || '',
          geography: isSavedraft
            ? row.substantiations['country__cr.name__v'] || ''
            : row.substantiations['geography'] || '',
          subtype: isSavedraft
            ? row.substantiations['related_reference__vr.subtype__v'] || ''
            : row.substantiations['subtype'] || '',
          link: isSavedraft
            ? row.substantiations['substantiation_link'] || ''
            : row.substantiations['link'] ||
              row.substantiations['substantiation_link'] ||
              '',
        };
        substantiationsArr = Object.values(substObj).every((val) => val === '')
          ? []
          : [substObj];
      }
    }
    return {
      statementText: row.statement || row.text || '',
      qualifier:
        row.qualifier || (Array.isArray(row.qualifier) ? row.qualifier[0] : ''),
      marketingChannel: row.marketing_channels
        ? Array.isArray(row.marketing_channels)
          ? row.marketing_channels.join(', ')
          : row.marketing_channels
        : '',
      supportStrategy: row.support_strategy_rich || row.support_strategy || '',
      substantiations: substantiationsArr,
      qualifierBold: false,
      marketingChannelExpanded: false,
      claim_la_bid: row.claim_la_bid,
      claim_la_id: row.claim_la_id || row.claim_la_name || '',
      claim_la_name: row.claim_la_name,
      claim_la_order: row.claim_la_order,
      slno: row.slno,
      claimReviewData: row,
      substantiation_permission: row.substantiation_permission,
      editing_permission: row.editing_permission,
      claim_la_state_ui: row.claim_la_state_ui,
    };
  }
  // Helper to format Marketing Channel text: break after 7 characters, then next 7, then ... if more
  // Shows only the first two lines, then ellipsis if not expanded
  getMarketingChannelDisplay(row: StatementRow): {
    lines: string[];
    showEllipsis: boolean;
  } {
    const lines = row.marketingChannel.split('\n');
    if (row.marketingChannelExpanded || lines.length <= 2) {
      return { lines, showEllipsis: false };
    }
    return { lines: lines.slice(0, 2), showEllipsis: true };
  }

  expandMarketingChannel(row: StatementRow) {
    row.marketingChannelExpanded = true;
  }
  oncancelClick() {
    this.dialogRef.close(false);
  }
  getSubstantiationIds(element: any): string {
    return element.substantiations && element.substantiations.length
      ? element.substantiations
          .map((subst: any) => subst.substantiation_id)
          .join(', ')
      : '';
  }

  // ...existing code...

  onDeclineLatestUpdates() {
    // Pass savedInDraft back to parent as declined
    this.dialogRef.close({
      action: 'decline',
      savedInDraft: this.savedInDraft[0],
    });
  }

  onAcceptLatestUpdates() {
    // Pass latestUpdates back to parent as accepted
    this.dialogRef.close({
      action: 'accept',
      updatedClaim: this.latestUpdates[0],
    });
  }

  getSubstantiationDescriptions(element: any): string[] {
    return element.substantiations && element.substantiations.length
      ? element.substantiations.map((subst: any) => subst.description || '')
      : [];
  }

  getSubstantiationShortDescriptions(element: any): string {
    const descs = this.getSubstantiationDescriptions(element);
    return descs
      .map((desc) => (desc.length > 10 ? desc.slice(0, 10) + '...' : desc))
      .join(', ');
  }

  getSubstantiationDescriptionsTooltip(element: any): string {
    return this.getSubstantiationDescriptions(element).join(', ');
  }

  /**to sanitize html elements */
  sanitizeHTML(content: string): SafeHtml {
    const div = document.createElement('div');
    div.innerHTML = content;
    return div.textContent || div.innerText || '';
  }
}
